import { Navigate } from 'react-router-dom';
import { useStore } from '../context/StoreContext';

const AdminRoute = ({ children }) => {
  const { user, loading, userRole } = useStore();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bgDark">
        <div className="text-neonBlue text-xl">Cargando...</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" />;
  if (userRole !== "admin") return <Navigate to="/account" />;

  return children;
};

export default AdminRoute;
